import { Link } from "react-router-dom";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export default function NotFound() {

  const popularPages = [

    {
      name: "EMI Calculator",
      path: "/emi-calculator",
    },

    {
      name: "Tax Calculator",
      path: "/tax-calculator",
    },

    {
      name: "Age Calculator",
      path: "/age-calculator",
    },

    {
      name: "Password Generator",
      path: "/password-generator",
    },

  ];

  return (
    <>
      <SEO
        title="404 - Page Not Found | Online Tools Center"
        description="The page you are looking for does not exist. Explore our free online tools and calculators."
        keywords="404 page not found, online tools"
        url="https://online-tools-center.vercel.app/404"
      />

      <Navbar />

      <section
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          background:
            "linear-gradient(135deg,#eff6ff,#ffffff)",
          padding: "40px 15px",
        }}
      >

        <div className="container">

          <div
            className="card border-0 shadow-lg rounded-4 text-center mx-auto"
            style={{
              maxWidth: "850px",
            }}
          >

            <div className="card-body p-4 p-md-5">

              <div
                style={{
                  fontSize:
                    "clamp(80px,15vw,150px)",
                  fontWeight: "900",
                  lineHeight: 1,
                  color: "#2563eb",
                }}
              >
                404
              </div>

              <h1
                className="fw-bold mt-3 mb-3"
              >
                Oops! Page Not Found
              </h1>

              <p
                className="text-muted mx-auto"
                style={{
                  maxWidth: "600px",
                  fontSize: "18px",
                }}
              >
                The page you are trying to access
                may have been removed,
                renamed,
                or is temporarily unavailable.
              </p>

              <div
                className="d-flex flex-wrap justify-content-center gap-3 mt-4"
              >

                <Link
                  to="/"
                  className="btn btn-primary px-4 py-2"
                >
                  Go To Homepage
                </Link>

                <Link
                  to="/contact-us"
                  className="btn btn-outline-primary px-4 py-2"
                >
                  Contact Support
                </Link>

              </div>

              {/* POPULAR PAGES */}

              <div className="mt-5">

                <h4 className="fw-bold mb-4">
                  Popular Tools
                </h4>

                <div className="row g-3">

                  {popularPages.map((page, index) => (

                    <div
                      className="col-md-6"
                      key={index}
                    >

                      <Link
                        to={page.path}
                        className="text-decoration-none"
                      >

                        <div
                          className="border rounded-4 p-3 h-100"
                          style={{
                            transition: "0.3s",
                            background: "#f8fafc",
                          }}
                        >

                          <h5 className="mb-0 text-dark">
                            {page.name}
                          </h5>

                        </div>

                      </Link>

                    </div>

                  ))}

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

      <Footer />

    </>
  );
}